import { Button, Offcanvas, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import { useEmailsDirectory } from './context/EmailsDirProvider';
import TabClients from './tabs/TabClients';
import TabOthers from './tabs/TabOthers';

const EmailsDirPanel = ({ show }: { show: boolean }) => {
    const { t } = useTranslation('EmailsDir');
    const model = useEmailsDirectory();
    return (
        <Offcanvas show={show} onHide={model.close} placement="end" className="off-emails-dir">
            <Offcanvas.Header className="border-bottom" closeButton={!model.busy}>
                <Offcanvas.Title>{t('title')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <div className="off-coming-form d-flex flex-column h-100">
                    <div className="off-coming-content px-3">
                        <Tabs variant="underline" activeKey={model.activeTab} onSelect={(key) => { if (key && !model.busy) model.setActiveTab(key); }} className="mb-3 invoice-tab border-bottom">
                            <Tab eventKey="clients" title={<><SolarIcon name="people" className="me-2 fs-14" />{t('clients')}</>}><TabClients /></Tab>
                            <Tab eventKey="others" title={<><SolarIcon name="card-list" className="me-2 fs-14" />{t('others')}</>}><TabOthers /></Tab>
                        </Tabs>
                    </div>
                    <div className="p-3 offcanvas-footer off-coming-footer d-flex justify-content-end gap-2">
                        <Button variant="secondary" disabled={model.busy} onClick={model.close}>{t('cancel')}</Button>
                        <Button variant="info" className="min100px" disabled={model.busy || !Object.keys(model.selected).length} onClick={model.choose}>
                            {t('select', { count: new Set(Object.values(model.selected)).size })}
                        </Button>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default EmailsDirPanel;
